import { render } from "./BaseButton.vue?vue&type=template&id=21ff1724&scoped=true"
const script = {}

import "./BaseButton.vue?vue&type=style&index=0&id=21ff1724&scoped=true&lang=css"

import exportComponent from "/home/lexmodo/projects/waitlist/waitlist/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21ff1724"]])

export default __exports__